require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /home/ec2-user/Source/aws-lex-web-ui/node_modules/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 261
// module chunks = 0